import { createAction, props } from '@ngrx/store';
import { PdtDetailModel } from '@app/models/shoppingmall/pdt-detail.model';
import { ResultProc } from '@app/models/system/result-proc.model';

// pdt detail
export const loadPdtInfo = createAction(
  "[Product API] load pdt info",
  props<{ pdtCd: string }>()
);

export const loadPdtInfoSuccess = createAction(
  "[Product API] load pdt info success",
  props<{ item: PdtDetailModel }>()
);

export const loadPdtInfoFailure = createAction(
  "[Product API] load pdt info failure",
  props<{ msg: any }>()
);

// pdt image
export const loadPdtImages = createAction(
  "[Product API] load pdt images",
  props<{ pdtCd: string, pathKind: string }>()
);

export const loadPdtImagesSuccess = createAction(
  "[Product API] load pdt images success",
  props<{ items: PdtDetailModel[] }>()
);

export const loadPdtImagesFailure = createAction(
  "[Product API] load pdt images failure",
  props<{ msg: any }>()
);

// pdt notify
export const loadPdtNotify = createAction(
  "[Product API] load pdt notify",
  props<{ pdtCd: string }>()
);

export const loadPdtNotifySuccess = createAction(
  "[Product API] load pdt notify success",
  props<{ items: PdtDetailModel[] }>()
);

export const loadPdtNotifyFailure = createAction(
  "[Product API] load pdt notify failure",
  props<{ msg: any }>()
);

// getPdtInfosByCateCd
export const loadPdtInfosByCateCd = createAction(
  "[Product API] loadPdtInfosByCateCd",
  (catecd: string, rowNum: string, prdCd: string, pathKind: string) => ({ catecd, rowNum, prdCd, pathKind })
);

export const loadPdtInfosByCateCdSuccess = createAction(
  "[Product API] loadPdtInfosByCateCd success",
  props<{ relatedProducts: PdtDetailModel[] }>()
);

export const loadPdtInfosByCateCdFailure = createAction(
  "[Product API] loadPdtInfosByCateCd failure",
  props<{ msg: any }>()
);


// set product name main heading
export const setProductNameMainHeading = createAction(
  "[Product Detail] set product name main heading",
  props<{ heading: string }>()
);

// getPdtReview
export const getPdtReview = createAction(
  "[Product API] getPdtReview",
  props<{ pdtCd: string, orderBy: string, page:number, len:number }>()
);

export const getPdtReviewSuccess = createAction(
  "[Product API] getPdtReview success",
  props<{ reviewProducts: PdtDetailModel[] }>()
);

export const getPdtReviewFailure = createAction(
  "[Product API] getPdtReview failure",
  props<{ msg: any }>()
);

export const getCountPdtReview = createAction(
  "[Product API] getCountPdtReview",
  props<{ pdtCd: string }>()
);

export const getCountPdtReviewSuccess = createAction(
  "[Product API] getCountPdtReviewSuccess success",
  props<{ total: Number }>()
);

export const getCountPdtReviewFailure = createAction(
  "[Product API] getCountPdtReviewFailure failure",
  props<{ msg: any }>()
);

// get grades of review
export const getGradeOfProduct = createAction(
  "[Product API] get grades of product",
  props<{ pdtCd: string }>()
);

export const getGradeOfProductSuccess = createAction(
  "[Product API] get grades of product success",
  props<{ gradeOfProducts: PdtDetailModel[] }>()
);

export const getGradeOfProductFailure = createAction(
  "[Product API] get grades of product failure",
  props<{ msg: any }>()
);

// get images of review
export const actionGetProductReviewImages = createAction(
  "[Product API] get images of product",
  props<{ pdtCd: string, page:number, len:number }>()
);

export const actionGetProductReviewImagesSuccess = createAction(
  "[Product API] get images of product success",
  props<{ productReviewImages: PdtDetailModel[] }>()
);

export const actionGetProductReviewImagesFailure = createAction(
  "[Product API] get images of product failure",
  props<{ msg: any }>()
);

// get total images of review
export const actionGetTotalProductReviewImages = createAction(
  "[Product API] get total images of product",
  props<{ pdtCd: string }>()
);

export const actionGetTotalProductReviewImagesSuccess = createAction(
  "[Product API] get total images of product success",
  props<{ totalProductReviewImages: Number }>()
);

export const actionGetTotalProductReviewImagesFailure = createAction(
  "[Product API] get total images of product failure",
  props<{ msg: any }>()
);

// save product review
export const actionSaveProductReview = createAction(
  "[Product API] save Product Review",
  props<{ params: any }>()
);

export const actionSaveProductReviewSuccess = createAction(
  "[Product API] save Product Review success",
  props<{ result: ResultProc }>()
);

export const actionSaveProductReviewFailure = createAction(
  "[Product API] save Product Review failure",
  props<{ result: ResultProc }>()
);

export const actionClearResult = createAction(
  "Clear result",
  props<{ result: ResultProc }>()
);

// save comment

export const saveCommentPdt = createAction(
  "[Product API] saveCommentPdt",
  props<{ params: any }>()
);

export const saveCommentPdtSuccess = createAction(
  "[Product API] saveCommentPdt success",
  props<{ result: ResultProc }>()
);

export const saveCommentPdtFailure = createAction(
  "[Product API] saveCommentPdt failure",
  props<{ result: ResultProc }>()
);

// load comment

export const loadCommentPdt = createAction(
  "[Product API] loadCommentPdt",
  props<{ seq:string[] , userid:string}>()
);

export const loadCommentPdtSuccess = createAction(
  "[Product API] loadCommentPdt success",
  props<{ items: PdtDetailModel[] }>()
);

export const loadCommentPdtFailure = createAction(
  "[Product API] loadCommentPdt failure",
  props<{ msg: any }>()
);

// clear product detail state
export const clearProductDetailState = createAction("[Product Detail] clear product detail state");